export default __webpack_public_path__ + "static/media/house-pattern.26665dac.png";